import React from 'react';

export default function GuestMenuHero({ settings, restaurant, children }) {
  return <section className="guest-menu-hero">
    <header className="guest-menu-header">{children}</header>
    <div className="guest-menu-intro">
      {settings.logo && <img className="guest-menu-logo" src={settings.logo} alt={restaurant ? `${restaurant} logo` : 'Restaurant logo'} />}
      {restaurant && <h1>{restaurant}</h1>}{settings.tagline && <p>{settings.tagline}</p>}
    </div>
  </section>;
}
